// extracted by mini-css-extract-plugin
export default {"nftGridContainer":"Buy_nftGridContainer__Wpc9t","nftContainerCard":"Buy_nftContainerCard__bx8kE","nftContainer":"Buy_nftContainer__6-CK-","title":"Buy_title__JEhPg"};